import { postCreditCheckScreening } from './creditCheckScreening'

export default {
  postCreditCheckScreening
}
